
import { Component, Vue } from "vue-property-decorator";

@Component
export default class TerminosYCondicionesComponent extends Vue {
  private titulo: string = this.$t("fields.terms").toString();
  private articulo: string = "los";

  private mounted() {
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "Privacidad") {
      this.titulo = "Políticas de Privacidad";
      this.articulo = "las";
    }
  }
}
